/**
 * MODULE: _shared/frontend-shell/src/design-system/components/AiAssistant/aiAssistantExport.ts
 * PURPOSE: Export assistant thread as Markdown for sharing or archival.
 */

import type { AiAssistantMessage } from './aiAssistantTypes';
import { partitionAssistantContent } from './assistantContentPartition';

export function buildMarkdownTranscript(
  messages: AiAssistantMessage[],
  sessionId: string,
  flowId: string
): string {
  const when = new Date().toISOString();
  const lines: string[] = [
    '# Brazn AI Assistant',
    '',
    `- Exported: ${when}`,
    `- Session: \`${sessionId}\``,
    flowId.trim() ? `- Flow: \`${flowId}\`` : '',
    '',
    '---',
    '',
  ].filter(Boolean);

  for (const m of messages) {
    if (m.role === 'assistant' && m.loading && !m.content.trim()) {
      lines.push('## Assistant', '', '_(generating…)_', '');
      continue;
    }
    const who = m.role === 'user' ? 'You' : 'Assistant';
    lines.push(`## ${who}`, '');
    if (m.error) {
      lines.push('> **Error**', '', '```', m.content, '```', '');
    } else {
      const body =
        m.role === 'assistant' ? partitionAssistantContent(m.content).displayBody.trim() : m.content.trim();
      lines.push(body || '_(empty)_', '');
    }
  }

  return lines.join('\n');
}

export function downloadMarkdownFile(filename: string, content: string): void {
  const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
